import React, { RefObject, useEffect } from 'react';
import { Label } from '../../../../../../../common/labels/labelTypes';
import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import LabelColorPicker from './LabelColorPicker';
import { cx } from '@milanote/roma/utils';
import { LabelColorHandlerReturnType } from '../hooks/useLabelColorHandler';
import { getColorDefaultHexValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import { DEFAULT_ELEMENT_COLOR } from '../../../../../../../common/colors/colorConstants';
import CustomColorInput from '../../colorTools/CustomColorInput';

import '../../colorTools/popup/desktop/DesktopColorPopup.scss';

type Props = LabelColorHandlerReturnType & {
    isPopupOpen: boolean;
    popupId: string;
    buttonSelector: string;
    customColorInputRef: RefObject<CustomColorInput>;
    triggerRef: RefObject<HTMLElement>;
    selectedLabel?: Label;
    openCustomColorPicker: () => void;
};

const DesktopLabelColorPopup: React.FC<Props> = ({
    popupId,
    buttonSelector,
    isPopupOpen,
    selectedLabel,
    tempColor,
    customColorInputRef,
    triggerRef,
    handleTempColorChange,
    handleColorChange,
    clearPreview,
    openCustomColorPicker,
}) => {
    useEffect(() => {
        if (isPopupOpen) return;

        clearPreview();
    }, [clearPreview, isPopupOpen]);

    if (!selectedLabel) return null;

    const labelColor = tempColor ?? selectedLabel.color;
    const labelColorHex = getColorDefaultHexValue(labelColor) || DEFAULT_ELEMENT_COLOR;

    return (
        <div className={cx('DesktopColorPopup', isPopupOpen && 'is-open')}>
            <CustomColorInput
                openerEventTarget={triggerRef.current ?? undefined}
                className="custom-color-picker-input"
                ref={customColorInputRef}
                initialColor={labelColorHex || labelColor}
                setTempColor={handleTempColorChange}
                setColor={handleColorChange}
            />

            <ToolbarPopup
                popupId={popupId}
                className="DesktopLabelColorPopup color-popup"
                buttonSelector={buttonSelector}
                showArrow
            >
                <LabelColorPicker
                    selectedColor={labelColor}
                    selectedColorHex={labelColorHex}
                    openCustomColorPicker={openCustomColorPicker}
                    handleColorChange={handleColorChange}
                />
            </ToolbarPopup>
        </div>
    );
};

export default DesktopLabelColorPopup;
